import React from 'react';
import { Switch, Route } from 'react-router-dom';
import EditCafeImagesAndLogo from './editCafeImagesAndLogo';
import MyCafeInfo from './index';

const MyCafeInfoRouter = props => {
  return (
    <Switch>
      <Route
        path="/my-cafe-info/edit-cafe-images"
        exact
        render={routeProps => <EditCafeImagesAndLogo {...routeProps} />}
      />
      <Route path="/" component={MyCafeInfo} />
    </Switch>
  );
};

export default MyCafeInfoRouter;
